import {
  Box,
  Button,
  Grid,
  GridItem,
  Icon,
  Img,
  SimpleGrid,
  Text,
} from '@chakra-ui/react';
import React, { useContext, useEffect, useState } from 'react';
import { motion } from 'framer-motion';

// Images

import { ScoreContext } from '../GamePreview';

import { ProfileContext } from '../EntirePreview';

const ChapterPage: React.FC<{
  formData?: any;
  imageSrc: any;
  questState: any;
  setQuestState: any;
  backgroundImg: any;
  demoBlocks: any;
  setCurrentScreenId: any;
  questOptions?: any;
  currentQuestNo?: any;
  setCurrentQuestNo?: any;
  gameQuest?: any;
  setData?: any;
  setType?: any;
  setOptions?: any;
  setFeedbackList?: any;
  preloadedAssets?: any;
  currentScreenId: any;
  setPreLogDatas: any;
  getPrevLogDatas: any;
  profileData: any;
  gameOptionSuffled: any;
  setRepeatPrevOption: any;
  setSelectedOption: any;
  questWiseMaxTotal: any;
  gameInfoTotalScore: any;
  gameInfo: any;
  // setIsLoading?: any;
  setModalLoaded?: any;
  modalLoaded?: any;
  setIsZoomComplete: any;
  isZoomComplete: any;
}> = ({
  imageSrc,
  demoBlocks,
  setCurrentScreenId,
  formData,
  questOptions,
  currentQuestNo,
  setCurrentQuestNo,
  gameQuest,
  questState,
  setQuestState,
  setData,
  setType,
  setOptions,
  setFeedbackList,
  preloadedAssets,
  currentScreenId,
  setPreLogDatas,
  getPrevLogDatas,
  profileData,
  gameOptionSuffled,
  setRepeatPrevOption,
  setSelectedOption,
  questWiseMaxTotal,
  gameInfoTotalScore,
  gameInfo,
  // setIsLoading,
  backgroundImg,
  modalLoaded,
  setModalLoaded,
  setIsZoomComplete,
  isZoomComplete,
}) => {
  const [questScores, setQuestScores] = useState(null);
  const [questWisePlayerScore, setQuestWisePlayerScore] = useState(null);

  const useData = useContext(ProfileContext);

  useEffect(() => {
    let GrandMaximumscore: any = {};
    let currentScores: any[];
    let getquest: any[];
    let maxScoreByQuest: { key: string; value: number }[] = [];
    profile?.score.map((profileQuest: any) => {
      if (!getquest?.includes(profileQuest?.quest)) {
        const scores = profile?.score;
        const sums: any = {};
        scores.forEach((score: any) => {
          const quest = score.quest;
          if (!sums[quest]) {
            sums[quest] = 0;
          }
          sums[quest] += score.score;
        });
        const getFinalscores = Object.entries(sums).map(([quest, score]) => ({
          quest,
          score,
        }));
        getquest = getFinalscores;
      }
    });
    const scores = profile?.score;
    const sums: any = {};
    scores?.forEach((score: any) => {
      const quest = score.quest;
      if (!sums[quest]) {
        sums[quest] = 0;
      }
      sums[quest] += score.score;
    });
    const Replayscores =
      profile?.replayScore.length > 0 ? profile?.replayScore : null;
    const Replaysums: { [key: number]: number } = {};
    Replayscores?.forEach((score: any) => {
      const quest = score.quest;
      if (!Replaysums[quest]) {
        Replaysums[quest] = 0;
      }

      Replaysums[quest] += score.score;
    });
    getquest?.map((profileQuest: any) => {
      const questStatus = questState[profileQuest?.quest];
      if (questStatus === 'completed') {
        // If the quest is completed, compare the scores
        if (
          sums[profileQuest?.quest] !== undefined &&
          Replaysums[profileQuest?.quest] !== undefined
        ) {
          currentScores =
            sums[profileQuest?.quest] > Replaysums[profileQuest?.quest]
              ? profile.score
              : profile.replayScore;
        } else {
          if (sums[profileQuest?.quest] !== undefined) {
            currentScores = profile?.score;
          } else if (Replaysums[profileQuest?.quest] !== undefined) {
            currentScores = profile?.replayScore;
          }
        }
      } else if (questStatus === 'Started') {
        // If the quest is started, consider the score
        currentScores = profile?.score.length > 0 ? profile.score : null; //null or currentScores or replayScore
      } else {
        if (
          sums[profileQuest?.quest] !== undefined &&
          Replaysums[profileQuest?.quest] !== undefined
        ) {
          currentScores =
            sums[profileQuest?.quest] > Replaysums[profileQuest?.quest]
              ? profile.score
              : profile.replayScore;
        } else {
          if (sums[profileQuest?.quest] !== undefined) {
            currentScores = profile?.score;
          } else if (Replaysums[profileQuest?.quest] !== undefined) {
            currentScores = profile?.replayScore;
          }
        }
      }
      const currentQuestseqId = Array.isArray(currentScores)
        ? currentScores.map((item) => item.seqId)
        : [];

      if (Array.isArray(currentScores) && currentScores.length > 0) {
        // Map currentScores to extract scores
        const scores = currentScores.map((item) => item.score);

        const result = currentQuestseqId.map((seqId) => {
          const QuestNo = seqId.split('.')[0];
          if (QuestNo == profileQuest?.quest) {
            const filteredOptions = questOptions?.filter(
              (option: any) => option.qpSequence == seqId,
            );
            const qpScoresOption = filteredOptions.map((option: any) =>
              parseInt(option.qpScore),
            );
            qpScoresOption.sort((a: any, b: any) => b - a);
            if (!GrandMaximumscore[profileQuest?.quest]) {
              GrandMaximumscore[profileQuest?.quest] = 0;
            }
            GrandMaximumscore[profileQuest?.quest] += qpScoresOption[0];
          }
          maxScoreByQuest = { ...maxScoreByQuest, ...GrandMaximumscore };
        });
      } else {
        console.log('*****Options are not provided.');
      }
    });
    setQuestScores(maxScoreByQuest);

    /**** setQuestPlayerScroe***/
    const getQuestwisePlayerScore = async () => {
      let result: { [key: number]: number } = {};
      if (demoBlocks) {
        Object.keys(demoBlocks).forEach((it: any, num: number) => {
          const scores = profile?.score;
          const sums: any = {};
          scores?.forEach((score: any) => {
            const quest = score.quest;
            if (!sums[quest]) {
              sums[quest] = 0;
            }
            sums[quest] += score.score;
          });

          let getFinalscores: any = {};
          Object.entries(sums).forEach(([quest, score]) => {
            const IntQuest = parseInt(quest);
            const newQuest = { ...getFinalscores, [IntQuest]: score };
            getFinalscores = { ...newQuest };
          });

          const Replayscores =
            profile?.replayScore.length > 0 ? profile?.replayScore : null;
          const Replaysums: { [key: number]: number } = {};
          Replayscores?.forEach((score: any) => {
            const quest = score.quest;
            if (!Replaysums[quest]) {
              Replaysums[quest] = 0;
            }
            Replaysums[quest] += score.score;
          });

          let getReplayFinalscores: { [key: number]: number } = {};
          Object.entries(Replaysums).forEach(([quest, score]) => {
            const IntQuest = parseInt(quest);
            getReplayFinalscores = {
              ...getReplayFinalscores,
              [IntQuest]: score,
            };
          });
          const TotalScore = Object.entries(getFinalscores).reduce(
            (tot: number, acc: any) => {
              if (it == acc[0]) {
                let questHasReplay = Object.keys(getReplayFinalscores).some(
                  (quest) => quest === acc[0],
                );
                if (questHasReplay) {
                  getReplayFinalscores[acc[0]] > acc[1]
                    ? (tot = getReplayFinalscores[acc[0]])
                    : (tot = acc[1]);
                } else {
                  tot = acc[1];
                }
                return tot;
              }
            },
            0,
          );
          result = {
            ...result,
            [parseInt(it)]: TotalScore ? TotalScore : getFinalscores[it],
          };
        });
      }
      return result;
    };

    getQuestwisePlayerScore().then((score: any) => {
      setQuestWisePlayerScore(score);
    });
  }, []);

  const { profile, setProfile } = useContext(ScoreContext);

  useEffect(() => {
    const currentQuest = profile?.currentQuest;

    gameQuest.map((item: any, index: number) => {
      const questNoAsString = item.gameQuestNo.toString();

      if (profile?.completedLevels?.includes(questNoAsString)) {
        const scores = profile?.score;

        if (scores !== undefined) {
          const sums: any = {};
          scores.forEach((score: any) => {
            const quest = score.quest;
            if (!sums[quest]) {
              sums[quest] = 0;
            }
            sums[quest] += score.score;
          });
          const getFinalscores = Object.entries(sums).map(([quest, score]) => ({
            quest,
            score,
          }));

          const getscores = getFinalscores.find(
            (row: any) => row.quest == item.gameQuestNo,
          );

          const finalscore = getscores?.score ?? 0;

          if (formData?.gameDisableOptionalReplays === 'false') {
            if (item?.gameIsSetMinPassScore === 'true') {
              const getminpassscore = item?.gameMinScore;
              if (
                finalscore >= getminpassscore &&
                finalscore < item?.gameTotalScore
              ) {
                if (Object.entries(questState).length === 0) {
                  setQuestState((prevquestdataList: any) => ({
                    ...prevquestdataList,
                    [item.gameQuestNo]: 'Started',
                  }));
                }
              } else {
                if (finalscore !== undefined) {
                  const status =
                    gameInfo?.gameData?.gameDisableOptionalReplays === 'false'
                      ? 'replayallowed'
                      : 'completed';

                  if (Object.entries(questState).length === 0) {
                    setQuestState((prevquestdataList: any) => ({
                      ...prevquestdataList,
                      [item.gameQuestNo]: 'Started',
                    }));
                  }
                } else {
                  setQuestState((prevquestdataList: any) => ({
                    ...prevquestdataList,
                    [item.gameQuestNo]: 'Started',
                  }));
                }
              }
            } else {
              if (finalscore !== undefined) {
                if (Object.entries(questState).length === 0) {
                  setQuestState((prevquestdataList: any) => ({
                    ...prevquestdataList,
                    [item.gameQuestNo]: 'Started',
                  }));
                }
              } else {
                const scores =
                  profile?.playerGrandTotal?.questScores[currentQuest];

                if (scores === 0) {
                  const status =
                    gameInfo?.gameData?.gameDisableOptionalReplays === 'false'
                      ? 'replayallowed'
                      : 'completed';
                  const finalscore = 0;

                  if (
                    finalscore === 0 &&
                    profile.compQuest.includes(questNoAsString)
                  ) {
                    if (item?.gameIsSetMinPassScore === 'false') {
                      setQuestState((prevquestdataList: any) => ({
                        ...prevquestdataList,
                        [item.gameQuestNo]: status,
                      }));
                    }
                  }
                } else {
                  setQuestState((prevquestdataList: any) => ({
                    ...prevquestdataList,
                    [item.gameQuestNo]: 'Started',
                  }));
                }
              }
            }
          } else {
            if (finalscore !== undefined) {
              if (Object.entries(questState).length === 0) {
                setQuestState((prevquestdataList: any) => ({
                  ...prevquestdataList,
                  [item.gameQuestNo]: 'Started',
                }));
              } else if (questState[item.gameQuestNo] === 'locked') {
                setQuestState((prevquestdataList: any) => ({
                  ...prevquestdataList,
                  [item.gameQuestNo]: 'Started',
                }));
              }
            } else {
              if (Object.entries(questState).length === 0) {
                setQuestState((prevquestdataList: any) => ({
                  ...prevquestdataList,
                  [item.gameQuestNo]: 'Started',
                }));
              }
            }
          }
        }
      } else {
        setQuestState((prevquestdataList: any) => ({
          ...prevquestdataList,
          [item.gameQuestNo]: 'locked',
        }));
      }
    });
  }, [profile]);

  const handleChapter = (it: any) => {
    if (isZoomComplete) {
      setIsZoomComplete(false);
    }

    setCurrentQuestNo(it);
    for (let values in questState) {
      if (values === it) {
        if (questState[it] !== 'Locked') {
          useData?.setMotionEffect(true);
        } else {
          useData?.setMotionEffect(false);
        }
      }
    }
    setTimeout(() => {
      const Completionpage = Object.entries(questState).map(
        ([questId, status]) => ({ questId, status }),
      );
      const OpenStraigntCompletionPage = Completionpage.find(
        (row: any) => row.questId === it && row.status === 'completed',
      );
      if (
        OpenStraigntCompletionPage !== undefined &&
        formData?.gameDisableOptionalReplays === 'true'
      ) {
        setProfile((prev: any) => {
          const data = { ...prev };
          data.currentQuest = it;
          if (profile.compQuest.length === 0) {
            data.compQuest = [String(it)];
          } else if (
            !profile.compQuest.includes(String(it)) &&
            profile.compQuest.length !== 0
          ) {
            data.compQuest = [...data.compQuest, String(it)];
          }
          return data;
        });

        setCurrentScreenId(6);
      } else if (
        formData?.gameDisableOptionalReplays === 'true' &&
        Completionpage.find(
          (row: any) => row.questId === it && row.status !== 'Started',
        )
      ) {
        setProfile((prev: any) => {
          const data = { ...prev };
          data.currentQuest = it;
          if (profile.compQuest.length === 0) {
            data.compQuest = [String(it)];
          } else if (!profile.compQuest.includes(String(it))) {
            data.compQuest = [...data.compQuest, String(it)];
          }
          return data;
        });

        setCurrentScreenId(6);
      } else {
        if (profile?.completedLevels?.includes(it)) {
          setPreLogDatas((prev: any) => ({
            ...prev,
            screenIdSeq: [currentScreenId],
          }));

          setType(demoBlocks[it]['1']?.blockChoosen);
          setData(demoBlocks[it]['1']);
          setFeedbackList([]);
          setRepeatPrevOption([]);
          setSelectedOption(null);
          if (demoBlocks[it]['1']?.blockChoosen === 'Interaction') {
            const optionsFiltered = [];
            const primarySequence = demoBlocks[it]['1'].blockPrimarySequence;
            for (const option of questOptions) {
              if (profileData?.Audiogetlanguage.length > 0) {
                if (option?.qpSequence === primarySequence) {
                  const profilesetlan = profileData?.Audiogetlanguage.find(
                    (key: any) => key?.textId === option.qpOptionId,
                  );
                  if (profilesetlan) {
                    const languagecont = {
                      ...option,
                      qpOptionText: profilesetlan.content,
                    };
                    optionsFiltered.push(languagecont);
                  } else {
                    optionsFiltered.push(option);
                  }
                }
              } else {
                if (option?.qpSequence === primarySequence) {
                  optionsFiltered.push(option);
                }
              }
            }
            if (gameOptionSuffled === 'true') {
              for (let i = optionsFiltered.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [optionsFiltered[i], optionsFiltered[j]] = [
                  optionsFiltered[j],
                  optionsFiltered[i],
                ]; // Swap elements at indices i and j
              }
            }
            setOptions(optionsFiltered);
          }

          const updatedCompletedLevels = new Set([
            ...profile?.completedLevels,
            it,
          ]);
          const resettedReplayScore =
            profile?.replayScore &&
            profile.replayScore.filter(
              (score: any) => parseInt(score.quest) !== parseInt(it),
            );
          setProfile((prev: any) => ({
            ...prev,
            currentQuest: it,
            replayScore: [...resettedReplayScore],
            completedLevels: [...updatedCompletedLevels],
          }));
          setCurrentScreenId(2);
        }
      }
    }, 300);
  };
  const container = {
    hidden: { opacity: 1, scale: 0 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        delayChildren: 0.8,
        staggerChildren: 1,
      },
    },
  };
  const item = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
    },
  };

  return (
    <>
      <Box
        position="relative"
        maxW="100%"
        w={'100vw'}
        height="100vh"
        backgroundImage={preloadedAssets?.introBgImage}
        backgroundSize={'cover'}
        backgroundRepeat={'no-repeat'}
        className="chapter_potrait"
      >
        <Grid
          templateColumns="repeat(1, 1fr)"
          gap={4}
          position="absolute"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
          width="75%"
          placeItems={'center'}
        >
          <GridItem colSpan={1} position={'relative'}>
            <Img
              src={preloadedAssets.QueueBackground}
              h={'auto'}
              maxW={'100%'}
              loading="lazy"
            />
            <Box className="chapter_title">Quest</Box>
            <Box className={'chapters_list_box'}>
              <Box w={'90%'}>
                <motion.div
                  className="container"
                  variants={container}
                  initial="hidden"
                  animate="visible"
                >
                  <SimpleGrid
                    columns={{ base: 3, sm: 3, md: 3 }}
                    spacing={{ base: 7, md: 4, lg: 7 }}
                  >
                    {gameInfo?.blocks &&
                      Object.keys(gameInfo?.blocks).map(
                        (it: any, num: number) => {
                          const questCondition =
                            questState[it] === 'Started' ||
                            questState[it] === 'completed' ||
                            questState[it] === 'replayallowed';
                          const questwisescore = gameInfoTotalScore?.filter(
                            (item: any) => item.gameQuestNo === parseInt(it),
                          );
                          return (
                            <motion.div
                              key={num}
                              className="item"
                              variants={item}
                            >
                              {gameInfo.gameQuest.some(
                                (row: any) => row.gameQuestNo == it,
                              ) && (
                                <Box
                                  position={'relative'}
                                  className="level_update"
                                  onClick={() =>
                                    profile?.completedLevels?.includes(it)
                                      ? handleChapter(it)
                                      : null
                                  }
                                >
                                  <Img
                                    src={backgroundImg}
                                    width={'97%'}
                                    transform={'translate(2px, 1px)'}
                                    filter={
                                      questCondition ? 'none' : 'grayscale(1)'
                                    }
                                  />
                                  <Img
                                    className="queue-screen"
                                    position={'absolute'}
                                    left={'-2px'}
                                    top={'-2px'}
                                    src={
                                      questCondition
                                        ? preloadedAssets.QueueScreen
                                        : preloadedAssets.Lock
                                    }
                                    zIndex={999}
                                  />
                                  <Box
                                    w={'100%'}
                                    position={'absolute'}
                                    top={'0'}
                                  >
                                    {questCondition ? (
                                      <Text
                                        textAlign={'center'}
                                        right={'65px'}
                                        fontFamily={'AtlantisText'}
                                        color={'#D9C7A2'}
                                        zIndex={999999}
                                        fontSize={'5vh'}
                                        className={'quest_title'}
                                        textShadow="-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000"
                                      >
                                        Quest {num + 1}
                                      </Text>
                                    ) : null}
                                  </Box>
                                  <Box
                                    w={'100%'}
                                    position={'absolute'}
                                    bottom={'0'}
                                    color={'#D9C7A2'}
                                    fontFamily={'AtlantisText'}
                                    zIndex={999999}
                                    display={'flex'}
                                    justifyContent={'center'}
                                  >
                                    {questCondition ? (
                                      <>
                                        <Text
                                          className="amount-score"
                                          textAlign={'center'}
                                        >
                                          {questWisePlayerScore &&
                                          questWisePlayerScore[it]
                                            ? questWisePlayerScore[it]
                                            : 0}
                                          /
                                          {questwisescore[0]?.gameQuestNo ===
                                          parseInt(it)
                                            ? questwisescore[0].gameTotalScore
                                            : 0}{' '}
                                        </Text>
                                        <Img
                                          className="money"
                                          // h={'25px'}
                                          // w={'auto'}
                                          src={preloadedAssets.MoneyIcon}
                                          zIndex={5}
                                        />{' '}
                                      </>
                                    ) : null}
                                  </Box>
                                  {profile?.completedLevels?.includes(it) ? (
                                    Object.entries(questState).map(
                                      ([questId, status], index) =>
                                        questId === it &&
                                        status === 'completed' ? (
                                          <Box className={'completed_level'}>
                                            {' '}
                                            <Box
                                              position={'relative'}
                                              display={'flex'}
                                              justifyContent={'center'}
                                            >
                                              {' '}
                                              <Img
                                                w={'40%'}
                                                h={'auto'}
                                                src={preloadedAssets?.Completed}
                                              />{' '}
                                            </Box>
                                          </Box>
                                        ) : questId === it &&
                                          status === 'replayallowed' ? (
                                          <Box className={'completed_level'}>
                                            {' '}
                                            <Box
                                              position={'relative'}
                                              display={'flex'}
                                              justifyContent={'center'}
                                            >
                                              {' '}
                                              <Img
                                                w={'40%'}
                                                h={'auto'}
                                                src={preloadedAssets?.Completed}
                                              />{' '}
                                            </Box>
                                          </Box>
                                        ) : questId === it &&
                                          status === 'locked' ? (
                                          <Img
                                            key={index}
                                            // src={preloadedAssets.Lock}
                                            className="lock"
                                            width={'97%'}
                                            position={'absolute'}
                                            bg={'#2b2828d6'}
                                            top={'0'}
                                          />
                                        ) : questId === it &&
                                          status === 'Started' ? null : null,
                                    )
                                  ) : (
                                    <Img
                                      // src={preloadedAssets.Lock}
                                      className="lock"
                                      width={'97%'}
                                      position={'absolute'}
                                      bg={'#2b2828d6'}
                                      top={'0'}
                                    />
                                  )}
                                </Box>
                              )}
                            </motion.div>
                          );
                        },
                      )}
                  </SimpleGrid>
                </motion.div>
              </Box>
            </Box>
          </GridItem>
        </Grid>
      </Box>
    </>
  );
};

export default ChapterPage;
